import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.252 2.25C15.4946 2.25 16.502 3.25736 16.502 4.5V9C16.502 10.2426 15.4946 11.25 14.252 11.25H13.502V12C13.502 13.2426 12.4946 14.25 11.252 14.25H8.0713L4.86619 16.0306C4.63389 16.1597 4.35064 16.1562 4.12161 16.0214C3.89257 15.8866 3.75195 15.6407 3.75195 15.375V14.25C2.50931 14.25 1.50195 13.2426 1.50195 12V7.5C1.50195 6.25736 2.50931 5.25 3.75195 5.25H4.50195V4.5C4.50195 3.25736 5.50931 2.25 6.75195 2.25H14.252ZM6.00195 5.25H11.252C12.4946 5.25 13.502 6.25736 13.502 7.5V9.75H14.252C14.6662 9.75 15.002 9.41421 15.002 9V4.5C15.002 4.08579 14.6662 3.75 14.252 3.75H6.75195C6.33774 3.75 6.00195 4.08579 6.00195 4.5V5.25Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }